<div #panelWrapper class="wk-tc-cross-links-panel-wrapper" [class.open]="isVisible">
  <div class="wk-tc-cross-links-panel" #panelContainer>
    <!-- Panel Header -->
    <div class="panel-header">
      <h3 class="panel-title">{{ 'APP.CITATIONS.CROSS_LINKS_PANEL.TITLE' | translate }}</h3>
      <button class="panel-close-btn" (click)="hide()" [title]="'APP.CITATIONS.CROSS_LINKS_PANEL.CLOSE' | translate">
        <span>&times;</span>
      </button>
    </div>

    <!-- Panel Content -->
    <div class="panel-content">
      <!-- Loading Spinner when switching between citation tabs -->
      <div *ngIf="isLoadingCitationType" class="loading-overlay">
        <div class="spinner"></div>
      </div>

      <div *ngIf="trackChangesList.length === 0 && !isLoadingCitationType" class="empty-state">
        <p>{{ 'APP.CITATIONS.CROSS_LINKS_PANEL.NO_TRACK_CHANGES' | translate }}</p>
      </div>

      <div *ngIf="trackChangesList.length > 0 && !isLoadingCitationType" class="changes-list">
        <div class="bulk-actions">
          <button class="bulk-action-btn reject-all" [disabled]="!hasActionableChanges()" (click)="rejectAllChanges()"
            [title]="'APP.CITATIONS.CROSS_LINKS_PANEL.REJECT_ALL' | translate">
            {{ 'APP.CITATIONS.CROSS_LINKS_PANEL.REJECT_ALL' | translate }}
          </button>
          <button class="bulk-action-btn accept-all" [disabled]="!hasActionableChanges()" (click)="acceptAllChanges()"
            [title]="'APP.CITATIONS.CROSS_LINKS_PANEL.ACCEPT_ALL' | translate">
            {{ 'APP.CITATIONS.CROSS_LINKS_PANEL.ACCEPT_ALL' | translate }}
          </button>
        </div>

        <div *ngFor="let change of trackChangesList" class="change-item"
          [ngClass]="['change-' + change.type, activeChangeId === change.id ? 'focused' : '']"
          [attr.data-change-id]="change.id" (click)="setActiveChange(change)"
          (keydown.enter)="setActiveChange(change)">
          <!-- User Avatar -->
          <div class="change-avatar" [style.background-color]="getAvatarColor(change.author)"
            title="{{ change.author }}">
            {{ getUserInitials(change.author) }}
          </div>

          <!-- Change Content -->
          <div class="change-content">
            <div class="change-header">
              <div class="change-author">{{ change.author }}</div>
              <div class="change-timestamp">{{ change.timestamp | date: 'short' }}</div>
            </div>
            <div class="change-text">
              <p [innerHTML]="normalizeAsteriskBoldMarkers(change.content)"></p>
            </div>

            <div class="change-replies" *ngIf="change.replies?.length" (keydown.enter)="$event.stopPropagation()"
              (click)="$event.stopPropagation()">
              <div class="reply-item" *ngFor="let reply of change.replies">
                <div class="reply-item-avatar" [style.background-color]="getAvatarColor(reply.author)"
                  title="{{ reply.author }}">
                  {{ getUserInitials(reply.author) }}
                </div>
                <div class="reply-item-content">
                  <div class="reply-item-header">
                    <span class="reply-item-author">{{ reply.author }}</span>
                    <div class="reply-item-meta">
                      <span class="reply-item-timestamp">{{ reply.timestamp | date: 'short' }}</span>
                      <div class="reply-item-actions">
                        <button class="reply-icon-btn" [title]="'APP.CITATIONS.CROSS_LINKS_PANEL.EDIT_REPLY' | translate" (click)="startEditReply(reply, $event)">
                          <span>✎</span>
                        </button>
                        <button class="reply-icon-btn" [title]="'APP.CITATIONS.CROSS_LINKS_PANEL.DELETE_REPLY' | translate"
                          (click)="deleteReply(change, reply, $event)">
                          <span>🗑</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="reply-item-text" *ngIf="!isEditingReply(reply)">
                    <p [innerHTML]="normalizeAsteriskBoldMarkers(reply.content)"></p>
                  </div>

                  <div class="reply-item-edit" *ngIf="isEditingReply(reply)">
                    <textarea class="reply-edit-input" [(ngModel)]="editReplyDraft"
                      (click)="$event.stopPropagation()"></textarea>
                    <div class="reply-edit-actions">
                      <button class="reply-action-btn post" (click)="saveReplyEdit(change, reply, $event)">{{ 'APP.CITATIONS.CROSS_LINKS_PANEL.POST' | translate }}</button>
                      <button class="reply-action-btn cancel" (click)="cancelEditReply($event)">{{ 'APP.CITATIONS.CANCEL' | translate }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="change-actions" *ngIf="change.type !== 'comment'">
            <button class="action-btn accept-btn" (click)="acceptChange(change.id)" [title]="'APP.CITATIONS.CROSS_LINKS_PANEL.ACCEPT_CHANGE' | translate">
              <span class="icon">✓</span>
            </button>
            <button class="action-btn reject-btn" (click)="rejectChange(change.id)" [title]="'APP.CITATIONS.CROSS_LINKS_PANEL.REJECT_CHANGE' | translate">
              <span class="icon">✕</span>
            </button>
          </div>

          <div class="reply-editor" *ngIf="change.type !== 'comment' && replyingToSuggestionId === change.id"
            (keydown.enter)="$event.stopPropagation()" (click)="$event.stopPropagation()">
            <div class="reply-input-row">
              <div class="reply-avatar" [style.background-color]="getAvatarColor('me')">
                {{ replyAvatarInitials }}
              </div>
              <input type="text" [(ngModel)]="replyDraft" class="reply-input" [placeholder]="'APP.CITATIONS.CROSS_LINKS_PANEL.REPLY_PLACEHOLDER' | translate"
                (keydown.enter)="submitReply(change.id); $event.preventDefault()" />
            </div>
            <div class="reply-actions" [class.reply-actions--visible]="(replyDraft?.length || 0) > 0">
              <button class="reply-action-btn post" [disabled]="!replyDraft?.trim()"
                (click)="submitReply(change.id)">{{ 'APP.CITATIONS.CROSS_LINKS_PANEL.POST' | translate }}</button>
              <button class="reply-action-btn cancel" (click)="cancelReply()">{{ 'APP.CITATIONS.CANCEL' | translate }}</button>
            </div>
          </div>

          <!-- Divider -->
          <div class="change-divider"></div>
        </div>
      </div>
    </div>
  </div>
</div>